import { render, staticRenderFns } from "./SidebarComponent.vue?vue&type=template&id=cfe1c7c2&scoped=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"
import style0 from "./SidebarComponent.vue?vue&type=style&index=0&id=cfe1c7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe1c7c2",
  null
  
)

export default component.exports